(function(){
  if (window.__ckInit) return; window.__ckInit = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var toastEl, toastTimer;
  function toast(msg,cart){
    if(!toastEl){toastEl=document.createElement('div');toastEl.className='ck-toast';toastEl.setAttribute('role','status');document.body.appendChild(toastEl);}
    toastEl.innerHTML='<span>'+msg+'</span>'+(cart?'<a href="'+root+'cart">View cart</a>':'');
    requestAnimationFrame(function(){toastEl.classList.add('is-show');});
    clearTimeout(toastTimer);toastTimer=setTimeout(function(){toastEl.classList.remove('is-show');},3200);
  }
  function updateCount(){
    return fetch(root+'cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){
      try{var ev=new Event('shopify:cart:lines-update',{bubbles:true});ev.promise=Promise.resolve({cart:{totalQuantity:cart.item_count},detail:{itemCount:cart.item_count}});document.dispatchEvent(ev);}catch(e){}
      try{document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:'ck-card',data:{source:'ck-card',itemCount:cart.item_count}}}));}catch(e){}
      document.querySelectorAll('[data-ck-cart-count]').forEach(function(el){el.textContent=cart.item_count;});
    });
  }
  document.addEventListener('click',function(e){
    var btn=e.target.closest('[data-ck-atc]');
    if(btn){
      e.preventDefault();
      var id=btn.getAttribute('data-ck-atc'); if(!id) return;
      var label=btn.innerHTML; btn.classList.add('is-loading');
      fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1}]})})
        .then(function(r){ if(!r.ok) return r.json().then(function(j){throw new Error(j.description||'Could not add');}); return r.json(); })
        .then(function(){
          btn.classList.remove('is-loading');btn.classList.add('is-done');btn.innerHTML='Added ✓';
          toast((btn.getAttribute('data-title')||'Item')+' added to cart',true);
          setTimeout(function(){btn.classList.remove('is-done');btn.innerHTML=label;},1800);
          return updateCount();
        })
        .catch(function(err){btn.classList.remove('is-loading');toast(err.message||'Could not add to cart');});
      return;
    }
    var w=e.target.closest('[data-ck-wish]');
    if(w){
      e.preventDefault();
      var h=w.getAttribute('data-ck-wish'), list=[];
      try{list=JSON.parse(localStorage.getItem('ck-wishlist')||'[]');}catch(x){}
      var i=list.indexOf(h);
      if(i>-1){list.splice(i,1);w.classList.remove('is-on');w.setAttribute('aria-pressed','false');toast('Removed from wishlist');}
      else{list.push(h);w.classList.add('is-on');w.setAttribute('aria-pressed','true');toast('Saved to wishlist');}
      try{localStorage.setItem('ck-wishlist',JSON.stringify(list));}catch(x){}
    }
  });
  function markWish(){
    var list=[];try{list=JSON.parse(localStorage.getItem('ck-wishlist')||'[]');}catch(x){}
    document.querySelectorAll('[data-ck-wish]').forEach(function(w){if(list.indexOf(w.getAttribute('data-ck-wish'))>-1){w.classList.add('is-on');w.setAttribute('aria-pressed','true');}});
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',markWish);}else{markWish();}
  document.addEventListener('shopify:section:load',markWish);
})();


(function(){
  function initHeroCarousels(){
    document.querySelectorAll('[data-ck-viewport]').forEach(function(viewport){
      if(viewport.__ckCarouselInit) return; viewport.__ckCarouselInit = true;
      var section = viewport.closest('[data-ck-hero]');
      if(!section) return;
      var track = viewport.querySelector('[data-ck-track]');
      if(!track) return;
      var slides = Array.prototype.slice.call(track.children);
      if(slides.length <= 1) return;
      var dotsWrap = section.querySelector('[data-ck-dots]');
      var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.children) : [];
      var prevBtn = section.querySelector('[data-ck-prev]');
      var nextBtn = section.querySelector('[data-ck-next]');
      var index = 0;
      var autoplay = section.getAttribute('data-autoplay') === 'true';
      var interval = parseInt(section.getAttribute('data-interval'), 10) || 5000;
      var timer = null;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function render(){
        track.style.transform = 'translateX(-' + (index * 100) + '%)';
        dots.forEach(function(d, di){
          var on = di === index;
          d.classList.toggle('is-active', on);
          d.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        slides.forEach(function(s, si){
          var link = s.querySelector('.ck-hero__img');
          if(link) link.setAttribute('tabindex', si === index ? '0' : '-1');
        });
      }
      function stop(){ if(timer){ clearInterval(timer); timer = null; } }
      function start(){
        stop();
        if(autoplay && !reduceMotion){
          timer = setInterval(function(){ go(index + 1); }, interval);
        }
      }
      function go(i){
        index = (i + slides.length) % slides.length;
        render();
      }
      function goUser(i){ go(i); start(); }
      dots.forEach(function(d, di){ d.addEventListener('click', function(){ goUser(di); }); });
      if(nextBtn) nextBtn.addEventListener('click', function(){ goUser(index + 1); });
      if(prevBtn) prevBtn.addEventListener('click', function(){ goUser(index - 1); });
      var startX = null, dragging = false;
      viewport.addEventListener('touchstart', function(e){ startX = e.touches[0].clientX; dragging = true; stop(); }, {passive:true});
      viewport.addEventListener('touchend', function(e){
        if(!dragging) return;
        dragging = false;
        var dx = e.changedTouches[0].clientX - startX;
        if(Math.abs(dx) > 40){ go(index + (dx < 0 ? 1 : -1)); }
        start();
      }, {passive:true});
      viewport.addEventListener('mouseenter', stop);
      viewport.addEventListener('mouseleave', start);
      viewport.addEventListener('focusin', stop);
      viewport.addEventListener('focusout', start);
      render();
      start();
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initHeroCarousels);}
  else{initHeroCarousels();}
  document.addEventListener('shopify:section:load',initHeroCarousels);
})();
